export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    roleOptions: {
      type: Array,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    },
    paymentOptions: {
      type: Array,
      required: true
    },
    planOptions: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    groups() {
      return [
        { key: 'role', label: 'Role', options: this.roleOptions },
        { key: 'status', label: 'Status', options: this.statusOptions },
        { key: 'payment', label: 'Payment', options: this.paymentOptions },
        { key: 'plan', label: 'Plan', options: this.planOptions }
      ]
    },
    activeOptions() {
      return this.groups.flatMap(group =>
        (this.modelValue[group.key] || [])
          .map(value => {
            const option = group.options.find(item => item.value === value)
            return option ? { ...option, groupKey: group.key } : null
          })
          .filter(Boolean)
      )
    },
    activeCount() {
      return this.activeOptions.length
    }
  },
  methods: {
    toggle(group, value, checked) {
      const current = this.modelValue[group] || []
      const next = checked ? [...current, value] : current.filter(item => item !== value)

      this.$emit('update:modelValue', {
        ...this.modelValue,
        [group]: next
      })
    },
    clearAll() {
      this.$emit('update:modelValue', { role: [], status: [], payment: [], plan: [] })
    }
  }
}
